import React, { Component } from 'react';
import { checkboxInterface } from 'constants/interfaces';
import { getContext } from 'services/context';
import PropTypes from 'prop-types';
import SearchBarContainer from 'molecules/search-bar/container';


let body = null;
let header = null;
let search = null;
let subMenu = null;


class LandingSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fixed: false,
      haveCheckboxes: false,
    };
  }

  componentDidMount() {
    body = document.querySelector('body');
    header = document.querySelector('.landing-page__search');
    search = document.querySelector('.seo__body__search-bar');
    subMenu = document.querySelector('.landing-page__sub-menu');
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.adCheckboxes.length && !nextProps.isPhone) {
      this.setState({ haveCheckboxes: true });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { top, height } = subMenu.getBoundingClientRect();
    const { fixed } = this.state;
    if (!fixed && top <= height) {
      body.style.paddingTop = `${height}px`;
      header.classList.add('-is-fixed');
      search.classList.add('-is-fixed');
      this.setState({ fixed: true });
    }
    if (fixed && top > height) {
      body.style.paddingTop = '';
      header.classList.remove('-is-fixed');
      search.classList.remove('-is-fixed');
      this.setState({ fixed: false });
    }
  }

  render() {
    const { haveCheckboxes, fixed } = this.state;
    return (
      <div className={ `landing-page__search ${haveCheckboxes ? 'haveCheckboxes' : ''} ${fixed ? '-is-fixed' : ''}` }>
        <SearchBarContainer
          className="seo__body__search-bar"
          isLandingSeo={ true }
        />
      </div>
    );
  }
}

LandingSearchBar.defaultProps = {
  adCheckboxes: [],
  isPhone: null,
};

LandingSearchBar.propTypes = {
  adCheckboxes: PropTypes.arrayOf(checkboxInterface),
  isPhone: PropTypes.string,
};

export default getContext(LandingSearchBar);
